import { Controller } from "@hotwired/stimulus"
let debounce = require("lodash/debounce");

export default class extends Controller {
  static targets = [ "location" ]
  // static values = {
  //   quantity: { type: Number, default: 1 },
  //   min: { type: Number, default: 1 },
  //   max: { type: Number, default: 20 },
  //   price: { type: Number, default: 0 },
  //   newRecord: { type: Boolean, default: true }
  // }
  query = "";

  connect() {
    console.log("locations controller");
    this._search = debounce(this._search, 300).bind(this)
  }

  // searchChanged
  search(event) {

    this.query = event.target.value.toLowerCase();
    this._search()
  }

  _search() {
    console.log("search", this.query);

    this.locationTargets.forEach(element => {
      var match = element.dataset["nameAddress"].includes(this.query);
      element.hidden = !match;
    });
  }

}
